import React from 'react';
import {
  RichText,
  Field,
  SitecoreContext,
  withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import './index.scss';

type RichTextEditorProps = {
  fields: {
    Content: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

const RichTextEditor = ({ fields, sitecoreContext }: RichTextEditorProps): JSX.Element => {
  if (fields) {
    return (
      <div>
        {sitecoreContext.pageEditing && (
          <>
            <p>RichTextEditor Component Edit Mode</p>
          </>
        )}
        <div className="richtexteditor">
          <RichText field={fields.Content} />
        </div>
      </div>
    );
  } else if (!fields && sitecoreContext.pageEditing) {
    return <p>Please setup the Datasource.</p>;
  }
  return <></>;
};

export default withSitecoreContext()(RichTextEditor);
